import { useCustomTranslation } from '../../../localization/hooks/useCustomTranslation';
import { moduleId } from '../config';

export const useAccomodationTranslation = (keyPrefix: string) =>
  useCustomTranslation({ moduleId, keyPrefix });
